import React, { useState, useEffect } from 'react';
import FeaturedScenarioCarouselDesktop from './FeaturedScenarioCarouselDesktop';
import FeaturedScenarioCarouselMobile from './FeaturedScenarioCarouselMobile';
import { ScenarioDefinitionListResponse } from '../../api/types/scenario';

interface FeaturedScenarioCarouselProps {
  featuredScenarios: ScenarioDefinitionListResponse[];
  onScenarioClick: (scenario: ScenarioDefinitionListResponse) => void;
}

const FeaturedScenarioCarousel: React.FC<FeaturedScenarioCarouselProps> = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const { featuredScenarios = [] } = props; // Provide default empty array

  // Don't render if there are no scenarios
  if (!featuredScenarios || featuredScenarios.length === 0) {
    console.log('No featured scenarios to display in carousel');
    return null;
  }

  useEffect(() => {
    // Function to check if the screen is mobile size
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Mark component as loaded after a short delay to ensure all assets are loaded
    const loadTimer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    // Clean up event listener and timer
    return () => {
      window.removeEventListener('resize', checkIfMobile);
      clearTimeout(loadTimer);
    };
  }, []);

  // Render the appropriate component based on screen size
  return isMobile ? (
    <FeaturedScenarioCarouselMobile {...props} />
  ) : (
    <FeaturedScenarioCarouselDesktop {...props} />
  );
};

export default FeaturedScenarioCarousel; 